/**
 * Файл содержит функции для работы со строками и подобные вспомогательыне функции
 */

/**
 * Выбирает вариант написания строки из 3 вариантов
 * для правильного соответсвия числительному
 *
 * @param  {Number} _number Число
 * @param  {Array} endings Массив из 3 вариантов
 *                                 соответсвующий форме числа для 1,2,5
 *                                 ['пример', 'примера', 'примеров']
 * @return {String}         Строка
 */
export function getNumberEnding(_number, endings) {
    var ending;
    var i;
    var number = _number % 100;

    if (number >= 11 && number <= 19) {
        ending = endings[2];
    } else {
        i = number % 10;
        switch (i) {
            case 1:
                ending = endings[0];
                break;
            case 2:
            case 3:
            case 4:
                ending = endings[1];
                break;
            default:
                ending = endings[2];
                break;
        }
    }

    return ending;
}

/**
 * Очищает строку от лишних идущих подряд пробелов или других пробельных
 * символов заменяя одним пробелом
 *
 * @param  {String} string          Входная строка
 * @param  {Boolean} clearBreaklines Флаг: Очищать ли пробельные символы?
 *                                   (по умолчанию только пробелы)
 * @return {String}                 Результирующая строка
 */
export function clearspaces(string, clearBreaklines) {
    if (clearBreaklines) {
        return string.replace(/\s+/g, ' ');
    }

    return string.replace(/(\x20|\x09|\x13|\xA0)+/g, ' ').replace(/\n+/g, '\n');
}

/**
 * Очищает начальные и конечные пробельные символы
 * @param  {String} string Входная строка
 * @return {String}        Результирующая строка
 */
export function ftrim(string) {
    return string.replace(/^\s+|\s+$/g, '');
}
